import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import SyncIcon from "@mui/icons-material/Sync";
import { Link } from "react-router-dom";

import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

export const ItemActionMenu = ({
  row,
  handleDelete,
  handleSync,
  canDelete = false, // default: false
  canEdit = true,
  syncingItemId = null,
}: {
  row: any;
  handleDelete?: any;
  handleSync?: any;
  canEdit?: boolean;
  canDelete?: boolean;
  syncingItemId?: string | null;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        <i className="bi bi-three-dots-vertical fs-5 text-dark"></i>
      </button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ 
          elevation: 3,
          sx: { 
            fontFamily: 'var(--bs-font-sans-serif) !important',
            '& *': {
              fontFamily: 'var(--bs-font-sans-serif) !important'
            },
            '& .MuiMenuItem-root': {
              minHeight: '28px',
              padding: '4px 12px'
            },
            '& .MuiMenuItem-root .MuiListItemText-primary': {
              fontSize: '13px !important',
              fontWeight: '500 !important'
            }
          }
        }}
      >
        {canEdit && (
          <MenuItem
            component={Link}
            to={`/edit-item/${row.original.item_id}`}
            onClick={handleClose}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Edit" />
          </MenuItem>
        )}

        <MenuItem
          component={Link}
          to={`/view-details/${row.original.item_id}`}
          onClick={handleClose}
        >
          <ListItemIcon>
            <VisibilityIcon fontSize="small" color="primary"/>
          </ListItemIcon>
          <ListItemText primary="View Details" sx={{ color: "primary.main" }}/>
        </MenuItem>

        {handleSync && (
          <MenuItem
            onClick={() => {
              if (syncingItemId !== row.original.item_id) {
                handleSync(row.original.item_sku);
                handleClose();
              }
            }}
            disabled={syncingItemId === row.original.item_id}
          >
            <ListItemIcon>
              <SyncIcon fontSize="small" sx={{ color: "#fd5e53" }}/>
            </ListItemIcon>
            <ListItemText 
              primary={syncingItemId === row.original.item_id ? "Syncing..." : "Sync Item"} 
              sx={{ color: "#fd5e53" }}
            />
          </MenuItem>
        )}

        {/* {canDelete && handleDelete && (
          <MenuItem
            onClick={() => {
              // your delete logic here
              handleDelete(row.original.item_id);
              handleClose();
            }}
            sx={{ color: "error.main" }}
          >
            <ListItemIcon>
              <DeleteIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText primary="Delete" />
          </MenuItem>
        )} */}
      </Menu>
    </>
  );
};
